import { useState } from "react";
import { Copy, ExternalLink, Images, Loader2, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { api, errMsg, waPhone } from "@/lib/api";

export function GalleryButton({ project, canShare, onShared }) {
  const [url, setUrl] = useState(null);
  const [busy, setBusy] = useState(false);
  const eligible = project.delivery || project.status === "COMPLETED";
  if (!eligible || (!canShare && !project.galleryToken)) return null;
  const open = async () => {
    if (project.galleryToken) return setUrl(`${window.location.origin}/gallery/${project.galleryToken}`);
    setBusy(true);
    try {
      const r = await api.post(`/projects/${project.id}/gallery`);
      setUrl(`${window.location.origin}/gallery/${r.data.galleryToken}`);
      onShared?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const text = `Your Gamerz Nation build ${project.projectCode} is ready! See the build gallery: ${url}`;
  return (
    <>
      <Button variant="outline" onClick={open} disabled={busy} data-testid="share-gallery-button">
        {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Images className="h-4 w-4 mr-2" />}Build Gallery
      </Button>
      <Dialog open={!!url} onOpenChange={() => setUrl(null)}>
        <DialogContent data-testid="gallery-share-dialog">
          <DialogHeader><DialogTitle>Build gallery — {project.projectCode}</DialogTitle>
            <DialogDescription>Shows stage photos and specs. Prices, phone number and address stay private.</DialogDescription></DialogHeader>
          <div className="flex gap-2"><Input readOnly value={url || ""} className="font-mono text-xs" data-testid="gallery-share-url" />
            <Button variant="outline" size="icon" onClick={() => { navigator.clipboard?.writeText(url); toast.success("Link copied"); }} data-testid="gallery-copy-link"><Copy className="h-4 w-4" /></Button></div>
          <div className="grid grid-cols-2 gap-2">
            <Button variant="outline" asChild><a href={url || "#"} target="_blank" rel="noreferrer" data-testid="gallery-open-link"><ExternalLink className="h-4 w-4 mr-2" />Open gallery</a></Button>
            <Button variant="outline" asChild><a href={`https://api.whatsapp.com/send?phone=${waPhone(project.customerPhone)}&text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer" data-testid="gallery-whatsapp-share">
              <MessageCircle className="h-4 w-4 mr-2" />Send on WhatsApp</a></Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
